import { useMutation } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface UpdateAgentCodeData {
  agentUuid: string;
  code: string;
  comment: string;
}

interface UpdateAgentCodeResponse {
  data: any;
}

export function useUpdateAgentCode() {
  const { keycloak } = useKeycloak();

  return useMutation({
    mutationFn: async (
      updateData: UpdateAgentCodeData
    ): Promise<UpdateAgentCodeResponse> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_IMPORT_ENGINE_ENDPOINT
        }/api/v1/bundles/generate_bundle/functions/update_agent_code`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify(updateData),
        }
      );

      const data = await response.json();

      return {
        data: data?.data,
      };
    },
  });
}
